<script setup lang="ts">
import { computed, ref, onMounted, useId } from 'vue'
const emit = defineEmits(['update:modelValue'])

const value = ref(false)

/** Unique per instance — the id was hardcoded, so multiple switches collided. */
const inputId = useId()

const props = defineProps({
    label: {
        type: String,
        default: '',
        required: true
    },
    data: {
        type: Boolean,
        default: null
    },
    required: {
        type: Boolean,
        default: false
    },
    containerClasses: {
        type: String,
        default: ''
    }
})

const inputVal = computed({
    get: () => {
        return props.data
    },
    set: (val) => {
        value.value = val
        emit('update:modelValue', val)
    }
})

onMounted(() => {
    if (props.data !== null) value.value = props.data
})
</script>
<template>
    <div class="flex flex-col gap-1.5" :class="containerClasses">
        <label v-if="!!label" :for="inputId" class="form-label">
            {{ label }}<span v-if="required" class="pl-1 text-danger">*</span>
        </label>

        <label class="relative inline-flex w-fit cursor-pointer items-center">
            <input :id="inputId" v-model="inputVal" type="checkbox" class="peer sr-only" />
            <span
                class="peer h-6 w-11 rounded-full bg-surface-3 ring-1 ring-inset ring-line-strong transition-colors after:absolute after:left-0.5 after:top-0.5 after:h-5 after:w-5 after:rounded-full after:bg-surface after:shadow after:transition-all after:content-[''] peer-checked:bg-success peer-checked:ring-success peer-checked:after:translate-x-5 peer-focus-visible:ring-2 peer-focus-visible:ring-primary/40"
            ></span>
        </label>
    </div>
</template>
<style scoped></style>
